import styled from 'styled-components';
import { rgba } from 'polished';

// CONSTANTS
import { MAIN_BLACK, GRAY_SUIT } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  padding-bottom: 65px;

  ${breakpoints.down('xs')} {
    padding-bottom: 35px;
  }

  .popupbox {
    z-index: 1220;

    &-wrapper {
      ${breakpoints.down('xs')} {
        max-width: 96%;
      }
    }

    &-titleBar {
      border-bottom: none;
      padding: 0 37px 0 24px;
    }

    &-content {
      padding: 5px;

      img {
        display: block;
        max-width: 100%;
      }
    }

    &-btn--close {
      right: 5px;
      top: 50%;
      margin-top: -6px;
      cursor: pointer;
    }
  }
`;

export const Content = styled.div`
  .swiper-container {
    display: flex;
    flex-direction: column-reverse;
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination-bullets {
    position: relative;
    margin-top: 30px;

    .swiper-pagination-bullet {
      opacity: 1;
      width: 10px;
      height: 10px;
      margin: 5px 7px;
      background: ${GRAY_SUIT};
      border-radius: 30px;

      &.swiper-pagination-bullet-active {
        background: ${MAIN_BLACK};
      }
    }
  }
`;

export const Thumbnail = styled.div`
  position: relative;
  width: 100%;
  min-width: 160px;
  min-height: 120px;
  cursor: pointer;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  border: 4px solid transparent;
  transition: border 0.4s;

  img {
    width: 100%;
  }

  &:hover,
  &:focus {
    border: 4px solid ${p => p.theme.palette.primary.main};
  }

  .play-fake {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    height: 70px;
    width: 70px;
    background-color: ${p => rgba(p.theme.palette.primary.main, 0.8)};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${p => p.theme.palette.primary.contrastText};
    text-indent: 3px;
  }
`;

export default Content;
